import React from "react";
import TableEntry from "../../common/table/TableEntry";
import { transactionFields } from "../../../../assets/fields/transaction-fields";
import { Transaction } from "../../../../types/donation/transaction";
import { TableField } from "../../../../types/table-field";
import { translations } from "../../../../utils/translations/translations-manager";
import { FilledButton } from "../../common/buttons/FilledButton";

interface TransactionsTableProps {
  tableData: Transaction[]
  setSelectedTransactionId: React.Dispatch<React.SetStateAction<string | undefined>>
  openTransactionRefund: () => void
}

const TransactionsTableBody: React.FC<TransactionsTableProps> = ({ tableData, setSelectedTransactionId, openTransactionRefund }) => {
  
  const filterAndFormatTransactionsByFields = (transaction: Transaction, fields: TableField[]): Record<string, any> => {
    const filteredRecords = Object.fromEntries(
      fields.map(field => {
        const key = field.name ?? ''
        const stringValue = key in transaction && field.formattingRule ? field.formattingRule(transaction[key]) : ''
        return [key, stringValue]
      }).sort(([keyA], [keyB]) => { 
        // TODO: implement ordering function
        if (keyA === "_id") return -1
        if (keyB === "_id") return 1
        const indexA = fields.findIndex(field => field.name === keyA)
        const indexB = fields.findIndex(field => field.name === keyB)
        return indexA - indexB
      })
    )
    return filteredRecords
  }

  return (
    <>
      {tableData.map((item) => (
        <tr key={item._id} className="bg-cents-grey odd:bg-cents-white hover:bg-cents-purple-lighter h-10 w-full text-sm 2xl:text-base">
          {Object.entries(filterAndFormatTransactionsByFields(item, transactionFields)).map(([key, value]) => (
            <TableEntry key={key} field={key} value={value} />
          ))}
          <td onClick={() => setSelectedTransactionId(item._id)} className="h-10 flex justify-center items-center">
            <FilledButton disabled={item.transactionStatus !== 'paid'} onClick={openTransactionRefund} label={translations.texts.refund.toString()} className="w-[140px] h-8 bg-red-500" />
          </td>
        </tr>
      ))}
    </>
  )
}

export default TransactionsTableBody